/** Display helpers: line prices are always pre-tax. */

export function linePreTaxTotal(line: {
  unitPrice?: number | string | null;
  quantity?: number | string | null;
  discountAmount?: number | string | null;
}): number {
  const unit = Number(line.unitPrice ?? 0);
  const qty = Number(line.quantity ?? 0);
  const disc = Number(line.discountAmount ?? 0);
  return Math.round(Math.max(unit * qty - disc, 0) * 100) / 100;
}
